import { Component, Input } from '@angular/core';

@Component({
  selector: 'gtd-help-menu',
  templateUrl: './help-menu.component.html',
})
export class HelpMenuComponent {
  @Input() cssClass = '';
  public knowledgeBaseLink = $localize`:@@common.knowledge_base_link:https://support.irev.com/en/categories/250626-partner-platform`;
}
